import { ReactElement } from "react";

export function SubmitButton(props: { value: string | number }): ReactElement {
  const { value } = props;

  return (
    <input
      className="p-1 w-32 text-white bg-blue-400 focus:ring-0 rounded-md"
      type="submit"
      value={value}
    />
  );
}
